<template>
  <section>

      <!-- Component for question title, description, number and required indicator -->
      <question-header />

      <!-- Specific markup for this question type -->
        <!-- button area (right side of question card) -->
        <b-field><button class="button is-primary is-medium"
            @click="isImageModalActive = true">
            Zoek opdrachtgever
        </button>
        <span v-if="typeof questionData.values[0] != 'undefined' && questionData.values[0] != null" class="client">Geselecteerd: <b><span v-html="questionData.values[0]"/></b></span>


          <!-- <b-field v-if="questionData.answer != ''" :label="questionData.values[0]" readonly/> -->

        </b-field>


        <b-modal :active.sync="isImageModalActive" :width="640" scroll="keep">
          <form action="">
              <div class="modal-card" style="width: auto">
                  <header class="modal-card-head">
                      <p class="modal-card-title">Zoek opdrachtgever bij CROW</p>
                  </header>
                  <section class="modal-card-body">
                    <div class="columns">
                        <b-field label="Postcode" ><input class="modal-input w7" spellcheck="false" @input="checkFormat()" v-model="PostalCode" maxlength="7"/></b-field>
                        <b-field label="Huisnummer" ><input class="modal-input w4" spellcheck="false" @input="checkFormat()" v-model="HouseNumber"/></b-field>
                    </div>
                    <button class="button button-padding" type="button" :disabled="!crowButton" @click="getClientID()">Zoek bij CROW</button>
                    <h2 v-if="ClientID != ''">Geselecteerde opdrachtgever: </h2>
                    <b-field v-if="ClientID != ''" :label="ClientName" readonly/>
                    <b-field v-else-if="busy == false && initial == false" :label="'Geen opdrachtgever gevonden op dit adres: '+PostalCodeTemp+' '+HouseNumberTemp"/>
                    <b-field v-else-if="busy == true" :label="'Bezig met zoeken...'"/>
                  </section>
                  <footer class="modal-card-foot">
                      <button class="button" type="button" @click="isImageModalActive = false">Terug</button>
                      <button class="button is-primary" type="button" @click="confirm()" :disabled="(ClientID == '')? true:false">Bevestigen</button>
                  </footer>
              </div>
          </form>

        </b-modal>

      </div>
      <br>
<comment-box ref="commentBox" v-if="questionData.comment=='1'" />

    <!-- Comment component to be redered when comments are allowed for this question -->

  </section>
</template>

<script>

import QuestionHeader from './QuestionHeader'
import CommentBox from './CommentBox'

export default {
  components: {
    'comment-box': CommentBox,
    'question-header': QuestionHeader
  },
  props: {
    questionData: Object, // eslint-disable-line vue/require-default-prop
    number: Number // eslint-disable-line vue/require-default-prop
  },
  data () {
    return {
      radio: 'default',
      comment: {
        showComment: false,
        commentFocussed: false,
        questionIsFocussed: false
      },
      PostalCode: '',
      HouseNumber: '',
      PostalCodeTemp: '',
      HouseNumberTemp: '',
      ClientName: '',
      ClientID: '',
      isImageModalActive: false,
      initial: true,
      busy: false,
      crowButton: false,
      config: {
        options: [],
        placeholder: 'Selecteer...',
        backgroundColor: '#f2f2f2',
        textColor: 'black',
        borderRadius: '5px',
        // border: '1px solid gray',
        width: 350
      }
    }
  },
  created () {

  },
  methods: {
    saveAnswer (selected) {
      if (this.questionData.question_type == 'calendar')
      {
        this.config.placeholder = selected.getTime()/1000
        this.questionData.answer = selected.getTime()/1000
      }
      else if (this.questionData.question_type == 'select_multiple_one')
      {
        this.config.placeholder = selected.value
        this.questionData.answer = selected.value
      }

      this.$store.commit('updateActivity', this.$store.getters.getActivities)
      // console.log(JSON.parse(localStorage.getItem('activities')))
    },
    checkbox(selected) {
      // console.log(selected);
    },
    confirm() {
      // console.log('bevest');
      this.questionData.answer = this.ClientID;
      this.questionData.values = [this.ClientName];
      this.saveAnswer(null);
      this.isImageModalActive = false;
    },
    checkFormat() {
      var post = this.PostalCode.replace(/([0-9]{4}) *([a-zA-Z]{2})/,'$1$2');
      var postcheck = this.PostalCode.replace(/([0-9]{4}) *([a-zA-Z]{2})/,'');
      var house = this.HouseNumber.replace(/([0-9]+[a-zA-Z]*)/,'$1');
      var housecheck = this.HouseNumber.replace(/([0-9]+[a-zA-z]*)/,'');
      this.crowButton = (post.length == 6 && postcheck.length == 0 && house.length > 0 && housecheck.length == 0) ? true : false;
    },
    getClientID()
    {
      if (!this.crowButton) return;
      this.PostalCodeTemp = this.PostalCode;
      this.HouseNumberTemp = this.HouseNumber;
      this.initial = false;
      this.ClientID = '';
      this.ClientName = '';
      this.busy = true;
      this.$http
       .get(process.env.EMET_API_URL +  '/survey/client/' + this.PostalCode + this.HouseNumber)
       .then((response) => {
         this.busy = false;
         var body = response.body;
         if (body.ClientID)
         {
           this.ClientID = body.ClientID;
           this.ClientName = body.ClientName;
         }
       })
    }
  },
  provide () {
    return {
      question: this.questionData,
      number: 0,
      comment: this.comment
    }
  }
}
</script>

<style scoped>

  .dropdown-question {
    z-index: 12;
  }
  .button-padding {
    margin-bottom: 1em;
  }
  .dropdown-padding {
    height: 80px;
  }
  .md-checkbox {
    display: flex;
  }
  .modal-input {
    outline: none;
    box-shadow: none;
    font-size: 160%;
    display: flex;
    padding: 0.3em;
    margin: 0.1em;
    border-radius: 0.2em;
    border: 0.1em solid #DDDDDD;
    color: #333333;
  }
  .modal-input:focus {

    border-color: lightgreen;
  }
  .client {
    font-size: 160%;
    padding-left: 0.7em;
  }
  .w7 {
    width: 7em;
  }
  .w4 {
    width: 4em;
  }

</style>



// WEBPACK FOOTER //
// src/components/elements/ClientID.vue